// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "3ae91a9e9a59ff8f94b8" + "-11.17.0-22f2341-202506190747.js";
};